import VueRouter from 'vue-router'
import Vue from 'vue'
import LuckyCookie from '@/utils/lucky-cookies'
import {
  homePageVisit,
  departmentInfo,
  randomNumber
} from '@/request/modules/home.js'

import store from '@/store'

import Home from '../view/home/home.vue'
import index from '../view/home/index.vue'
const templateView = () => import('@/view/face/templateView.vue')
const myProfile = () => import('@/view/userCenter/profile.vue')
const myVip = () => import('@/view/userCenter/vip.vue')
const vipSuccess = () => import('@/view/userCenter/vipSuccess.vue')
const addCredits = () => import('@/view/userCenter/addCredits.vue')
const payInfo = () => import('@/view/vip/payInfo.vue')
const payInfofail = () => import('@/view/vip/payInfofail.vue')
const login = () => import('@/view/login/login.vue')
const xlogin = () => import('@/view/login/xlogin.vue')
const privacyPolicy = () => import('@/view/userCenter/privacyPolicy.vue')
const disclaimer = () => import('@/view/userCenter/disclaimer.vue')
const termsofUse = () => import('@/view/userCenter/termsofUse.vue')

const AppSystem = () => import('@/view/appSystem/index.vue')
// const FullSearch = () => import('@/view/fullSearch/index.vue')

const Download = () => import('@/view/download/index.vue')
const DownloadDetail = () => import('@/view/download/components/detail.vue')

const Mailbox = () => import('@/view/mailbox')
const MailType = () => import('@/view/mailbox/mailType')

const Video = () => import('@/view/video')
const VideoDetails = () => import('@/view/video/videoDetails.vue')

const GaGrace = () => import('@/view/gaGrace')
const GaDetails = () => import('@/view/gaGrace/gaDetails.vue')

const Navigation = () => import('@/view/navigation')

const Error = () => import('@/components/404.vue')

Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/index',
  },
  {
    path: '/index',
    component: index,
    meta: {
      keepAlive: true 
    }
  },
  {
    path: '/home',
    component: Home,
    meta: {
      keepAlive: true 
    }
  },
  // 换脸页面
  {
    path: '/face/templateView',
    component: templateView,
  },
  // 用户中心页面
  {
    path: '/userCenter/profile',
    component: myProfile,
  },
  // 充值页面
  {
    path: '/userCenter/vip',
    component: myVip,
  },
  // 充值回退页面
  {
    path: '/userCenter/vipSuccess',
    component: vipSuccess,
  },
  // 购买积分页面
  {
    path: '/userCenter/addCredits',
    component: addCredits,
  },
  //充值成功页面
  {
    path: '/vip/payInfo',
    component: payInfo,
  },
  //充值失败页面
  {
    path: '/vip/payInfofail',
    component: payInfofail,
  },
  // 登录页面
  {
    path: '/login',
    component: login,
  },
  // X登录页面
  {
    path: '/xlogin',
    component: xlogin,
  },
  // privacyPolicy页面
  {
    path: '/privacyPolicy',
    component: privacyPolicy,
  },
  // disclaimer页面
  {
    path: '/disclaimer',
    component: disclaimer,
  },
  // termsofUse
  {
    path: '/termsofUse',
    component: termsofUse,
  },
  // 应用系统页面
  {
    path: '/appSystem',
    component: AppSystem,
  },
  // 全文搜索
  // {
  //   path: '/fullSearch',
  //   component: FullSearch,
  // },
  // 下载中心
  {
    path: '/download',
    component: Download,
  },
  // 软件详情
  {
    path: '/download/detail',
    component: DownloadDetail,
  },
  // 信箱
  // {
  //   path: '/mailbox',
  //   component: Mailbox
  // },
  // 信箱提交页面
  {
    path: '/mailbox/mailType',
    component: MailType
  },
  // 视频资源
  // {
  //   path: '/video',
  //   component: Video,
  // },
  // 视频详情
  {
    path: '/video/detail',
    component: VideoDetails,
  },
  // GA风采
  {
    path: '/gaGrace',
    component: GaGrace,
  },
  // GA风采详情
  {
    path: '/gaGrace/detail',
    component: GaDetails,
  },
  // 网站导航
  {
    path: '/navigation',
    component: Navigation,
  },
  {
    path: '*',
    component: Error,
  },
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

router.beforeEach(async (to, from, next) => {
  window.scrollTo(0, from.meta.savedPosition || 0);
  // 判断是否为登录状态
  try {
    // console.log(!!sessionStorage.getItem('nationCode') && !!sessionStorage.getItem('nationName'));
    // if (!(!!sessionStorage.getItem('nationCode') && !!sessionStorage.getItem('nationName'))) {
    //   const result = await departmentInfo()
    //   const {
    //     code,
    //     name
    //   } = result
    //   sessionStorage.setItem('nationCode', JSON.stringify(code))
    //   sessionStorage.setItem('nationName', JSON.stringify(name))
    //   homePageVisit()
    // }
  } catch (error) {
    next()
  }
  next()
})

export default router